<template>
  <v-col cols="12">
    <v-card>
      <v-card-text>
        <div class="text-center pa-3">
          <v-icon>check-circle</v-icon>
          <h2>Your ad is confirmed!</h2>
          <span>You will receive a notification from Facebook once it’s been reviewed.</span>
        </div>
        <v-stepper
          alt-labels
          class="elevation-0"
        >
          <v-stepper-header>
            <v-stepper-step step="1" complete>Items Confirmed</v-stepper-step>

            <v-divider/>

            <v-stepper-step step="2" complete>In Review</v-stepper-step>

            <v-divider/>

            <v-stepper-step step="3">Approved</v-stepper-step>
          </v-stepper-header>
        </v-stepper>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: 'issue-messages-confirmation',
  data () {
    return {}
  },
  methods: {}
}
</script>
